import { format, parse } from 'date-fns'

import { CustomViewPreset } from './DatePicker.types'

export const getYears = () => {
  const currentYear = new Date().getFullYear()
  return [currentYear - 2, currentYear - 1, currentYear, currentYear + 1]
}

export const getCustomViewPresets = () => {
  return ['7d', '30d', '90d', '6m', '12m', 'ytd'] satisfies CustomViewPreset[]
}

export const getMonthViewPresets = () => {
  const presets: string[] = []
  const referenceDate = new Date()

  for (let i = 0; i < 12; i++) {
    referenceDate.setMonth(i)
    presets.push(format(referenceDate, 'MMM'))
  }

  const years = getYears()

  return years.map(year => ({ year, presets }))
}

export const getQuarterViewPresets = () => {
  const years = getYears()
  return years.map(year => ({ year, presets: ['Q1', 'Q2', 'Q3', 'Q4'] }))
}

export const getHalfYearViewPresets = () => {
  const years = getYears()
  return years.map(year => ({ year, presets: ['H1', 'H2'] }))
}

export const formatDateToString = (value?: Date, options = { format: 'yyyy-MM-dd' }) => {
  return value ? format(value, options.format) : ''
}

export const parseStringToDate = (value: string, options = { format: 'yyyy-MM-dd' }) => {
  return parse(value, options.format, new Date())
}

export const buildAutoScrollableRef = ({
  presetYear,
  startDate = new Date(),
}: {
  presetYear: number
  startDate?: Date
}) => {
  return (node: HTMLDivElement | null) => {
    if (!node) return

    if (startDate.getFullYear() === presetYear) {
      node.scrollIntoView()
    }
  }
}
